module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('h2', {
    staticClass: "toc_head"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_iii",
      "title": "iii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780369702654_Chapter01"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780369702654_Chapter02"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780369702654_Chapter03"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_mi"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch_en"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bm"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bma"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_bma"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780369702654_Backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bde239d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780369702654_Contents.vue
// module id = 63
// module chunks = 0